module.exports = __webpack_public_path__ + "img/2018-Winklinger.5b57a543.jpg";